/** Public build settings only. Server credentials must never reach customFields. */
function supportConfig(env) {
  const baseUrl = env.CHATWOOT_PUBLIC_BASE_URL ?? '';
  const inboxIdentifier = env.CHATWOOT_DOCS_INBOX_IDENTIFIER ?? '';
  if (!baseUrl && !inboxIdentifier) return {enabled: false, baseUrl: '', inboxIdentifier: ''};
  try {
    const url = new URL(baseUrl);
    if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash ||
        !['', '/'].includes(url.pathname) || !/^[A-Za-z0-9_-]{1,200}$/.test(inboxIdentifier)) {
      throw new Error();
    }
    return {enabled: true, baseUrl: url.origin, inboxIdentifier};
  } catch {
    throw new Error('Invalid public support configuration: provide both an HTTPS origin and a public docs inbox identifier, or leave both empty.');
  }
}
/** The same immutable bundle is promoted from QA to the canonical public site. */
function supportSessionForOrigin(support, currentOrigin, siteUrl) {
  try {
    const site = new URL(siteUrl);
    if (site.protocol !== 'https:' || site.username || site.password || currentOrigin !== site.origin) {
      return {enabled: false};
    }
    return support ?? {enabled: false};
  } catch {
    return {enabled: false};
  }
}

module.exports = {supportConfig, supportSessionForOrigin};
